import React from 'react'
import AccountCircle from '@material-ui/icons/AccountCircleOutlined'
import AllIcon from '@material-ui/icons/StarBorderOutlined'
import TimerIcon from '@material-ui/icons/TimerOutlined'
import FolderIcon from '@material-ui/icons/FolderOutlined'
import HomeIcon from '@material-ui/icons/HomeOutlined'
import InboxIcon from '@material-ui/icons/InboxOutlined'
import NextIcon from '@material-ui/icons/NextWeekOutlined'
import NotesIcon from '@material-ui/icons/NotesOutlined'
import CalendarIcon from '@material-ui/icons/TodayOutlined'
import RepeatIcon from '@material-ui/icons/RepeatOutlined'
import TrashIcon from '@material-ui/icons/DeleteOutlined'

import {
  AllPage,
  InboxPage,
  NextPage,
  NotesPage,
  ProfilePage,
  RepeatPage,
  ScheduledPage,
  SomedayPage,
  TodayPage,
  TrashPage,
  WaitingForPage
} from '../pages'
import { FOCUS } from './focus'

export const navigation = [
  {
    id: 'inbox',
    title: FOCUS.INBOX.title,
    path: '/',
    component: InboxPage,
    list: FOCUS.INBOX.id,
    image: {
      icon: <InboxIcon color='primary' />
    }
  },
  {
    id: 'all',
    title: 'View All',
    path: '/all',
    component: AllPage,
    list: [
      FOCUS.INBOX.id,
      FOCUS.TODAY.id,
      FOCUS.NEXT.id,
      FOCUS.SOMEDAY.id,
      FOCUS.WAITING.id,
      FOCUS.NOTES.id
    ].join(','),
    futureList: FOCUS.TODAY.id,
    dividerPost: true,
    image: {
      icon: <AllIcon color='primary' />
    }
  },
  {
    id: 'today',
    title: FOCUS.TODAY.title,
    path: '/now',
    component: TodayPage,
    list: FOCUS.TODAY.id,
    image: {
      icon: <HomeIcon color='primary' />
    }
  },
  {
    id: 'next',
    title: FOCUS.NEXT.title,
    path: '/next',
    component: NextPage,
    list: FOCUS.NEXT.id,
    image: {
      icon: <NextIcon color='primary' />
    }
  },
  {
    id: 'someday',
    title: FOCUS.SOMEDAY.title,
    path: '/someday',
    component: SomedayPage,
    list: FOCUS.SOMEDAY.id,
    image: {
      icon: <FolderIcon color='primary' />
    }
  },
  {
    id: 'waiting',
    title: FOCUS.WAITING.title,
    path: '/waiting',
    component: WaitingForPage,
    list: FOCUS.WAITING.id,
    image: {
      icon: <TimerIcon color='primary' />
    }
  },
  {
    id: 'notes',
    title: FOCUS.NOTES.title,
    path: '/notes',
    list: FOCUS.NOTES.id,
    component: NotesPage,
    dividerPost: true,
    image: {
      icon: <NotesIcon color='primary' />
    }
  },
  {
    id: 'scheduled',
    title: FOCUS.SCHEDULED.title,
    path: '/scheduled',
    futureList: FOCUS.TODAY.id,
    component: ScheduledPage,
    image: {
      icon: <CalendarIcon color='primary' />
    }
  },
  {
    id: 'repeating',
    title: FOCUS.REPEATING.title,
    path: '/repeating',
    component: RepeatPage,
    list: FOCUS.REPEATING.id,
    futureList: FOCUS.REPEATING.id,
    image: {
      icon: <RepeatIcon color='primary' />
    }
  },
  {
    id: 'profile',
    title: 'My Profile',
    path: '/profile',
    component: ProfilePage,
    sidebar: false,
    image: {
      icon: <AccountCircle color='primary' />
    }
  },
  {
    id: 'project',
    title: 'Project',
    path: '/project/:id',
    component: AllPage,
    sidebar: false
  },
  {
    id: 'trash',
    title: FOCUS.TRASH.title,
    path: '/trash',
    list: FOCUS.TRASH.id,
    count: false,
    component: TrashPage,
    position: 'bottom',
    image: {
      icon: <TrashIcon color='primary' />
    }
  }
]
